import { Box } from '@mui/material';
import BaseShimmer from './BaseShimmer';
import './shimmer.scss';

function HeaderShimmer({ className = '', style = {} }) {
  return (
    <Box className={`shimmer-header ${className}`} sx={style}>
      <BaseShimmer
        className="shimmer-logo"
        height="40px"
        width="120px"
        borderRadius="6px"
      />

      <Box className="shimmer-nav">
        <BaseShimmer
          className="shimmer-nav-item"
          height="20px"
          width="80px"
          borderRadius="4px"
        />
        <BaseShimmer
          className="shimmer-nav-item"
          height="20px"
          width="80px"
          borderRadius="4px"
        />
        <BaseShimmer
          className="shimmer-nav-item"
          height="20px"
          width="80px"
          borderRadius="4px"
        />
      </Box>

      <Box className="shimmer-buttons">
        <BaseShimmer
          className="shimmer-button"
          height="36px"
          width="100px"
          borderRadius="6px"
        />
        <BaseShimmer
          className="shimmer-button"
          height="36px"
          width="100px"
          borderRadius="6px"
        />
      </Box>
    </Box>
  );
}

export default HeaderShimmer;
